const TEXTBOX_FIELD_TYPE = 1;
const RADIO_FIELD_TYPE = 2;
const CHECKBOX_FIELD_TYPE = 3;
const WHEEL_FIELD_TYPE = 4;
const COMBINED_FIELD_TYPE = 5;
const DATA_RADIO_FIELD_TYPE = 6;
const STRATEGY_FIELD_TYPE = 7;
const PRICE_RANGE_FIELD_TYPE = 9;
const DCA_STRATEGY_FIELD_TYPE = 10;
export const WHEEL_FIELD_TYPE_STRING = "wheel";
export const RADIO_FIELD_TYPE_STRING = "radio";
export const COMBINED_FIELD_TYPE_STRING = "combined";
export const TEXTBOX_FIELD_TYPE_STRING = "textbox";
export const CHECKBOX_FIELD_TYPE_STRING = "checkbox";
export const DATA_RADIO_FIELD_TYPE_STRING = "data_radio";
export const STRATEGY_FIELD_TYPE_STRING = "strategy";
export const PRICE_RANGE_FIELD_TYPE_STRING = "price_range";
export const DCA_STRATEGY_FIELD_TYPE_STRING = "dca_strategy";
export const FIELD_TYPE_NUMBER_TO_STRING = {
  [WHEEL_FIELD_TYPE]: WHEEL_FIELD_TYPE_STRING,
  [RADIO_FIELD_TYPE]: RADIO_FIELD_TYPE_STRING,
  [COMBINED_FIELD_TYPE]: COMBINED_FIELD_TYPE_STRING,
  [TEXTBOX_FIELD_TYPE]: TEXTBOX_FIELD_TYPE_STRING,
  [CHECKBOX_FIELD_TYPE]: CHECKBOX_FIELD_TYPE_STRING,
  [DATA_RADIO_FIELD_TYPE]: DATA_RADIO_FIELD_TYPE_STRING,
  [STRATEGY_FIELD_TYPE]: STRATEGY_FIELD_TYPE_STRING,
  [PRICE_RANGE_FIELD_TYPE]: PRICE_RANGE_FIELD_TYPE_STRING,
  [DCA_STRATEGY_FIELD_TYPE]: DCA_STRATEGY_FIELD_TYPE_STRING,
};

export const CUSTOM_STRATEGIES_ITEM_NAME = "Custom Strategies";
export const DCA_STRATEGIES_ITEM_NAME = "DCA Strategies";

export const CARD_MAX_WIDTH = 600;
